import React from "react";
import { useFileExplorerStore } from "@presentation/stores/FileExplorerStore";

export const SelectionStatistics: React.FC = () => {
  // read the selectedGridData from the InventoryStore
  const gridData = useFileExplorerStore((state) => state.selectedState);
  const selectedFiles = Object.values(gridData).filter(
    (file) => (file as { isFolder?: boolean }).isFolder !== true);
  const selectedCount = selectedFiles.length;

  // sum the file size of the selected items. Filter all where isSelected is true
  const selectedSize =
    selectedFiles.reduce((acc: number, file: { sizeInBytes: number }) => {
      return acc + (file.sizeInBytes ?? 0);
    }, 0) /
    (1024 * 1024 * 1024); // convert bytes to GiB

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#eeeeee",
        borderRadius: "3px",
        flexGrow: 1,
        height: "0.8rem",
        padding: "1rem",
        boxSizing: "border-box",
      }}
    >
      <div>{selectedCount} MS-Files selected</div>
      <div>{selectedSize.toFixed(2)} GiB selected</div>
    </div>
  );
};
